/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import InputField from "../../components/common/new/InputField/InputField";
import useQueryParams from "../../hooks/useQueryParams";
import { SET_DIVISIONS, SET_SUB_DIVISIONS } from "../../redux/actionTypes/meta";
import IntroductionFormApi from "../../services/api/introductionForm";
import { isEmptyObj } from "../../utils/helper";

function PersonalDetailsSearch({ onMemberIdChange, onMemberNameChange }) {
  const [divisionVal, setDivisionVal] = useState("");
  const [divisions, setDivisions] = useState([]);

  const dispatch = useDispatch();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const getDivisions = async () => {
    const response = await IntroductionFormApi.getDivisions();
    setDivisions(response.data);
    setMetaDataInRedux(SET_DIVISIONS, response.data);
  };

  useEffect(() => {
    getDivisions();
  }, []);

  const handleMemberIdChange = (event) => {
    const memberId = event.target.value;
    onMemberIdChange(memberId);
  };

  const handleMemberNameChange = (event) => {
    const memberName = event.target.value;
    onMemberNameChange(memberName);
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setDivisionVal(query?.divisionId || "");
    } else {
      setDivisionVal("");
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    if (divisions.length && divisionVal) {
      const newSubDivisions =
        divisions.find(
          (division) => division.divisionId === Number(divisionVal)
        )?.subDivisions ?? [];
      setMetaDataInRedux(SET_SUB_DIVISIONS, newSubDivisions);
    }
  }, [divisions, divisionVal]);

  return (
    <Box
      sx={{
        width: "100%",
        pr: { xs: "20px", sm: 0 },
        // ✅ Global styling for all fields
        "& .MuiInputBase-root": {
          height: "40px !important",
          fontSize: "14px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiInputLabel-root": {
          fontSize: "14px !important",
          fontWeight: 600,
        },
        "& .MuiInputLabel-shrink": {
          lineHeight: "1.4375em",
        },
        "& .MuiOutlinedInput-input": {
          padding: "8.5px 14px !important",
          height: "auto !important",
          fontSize: "14px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
        },
        "& .MuiTextField-root": {
          "& .MuiInputBase-root": {
            height: "40px",
            alignItems: "center",
          },
        },
        "& .MuiInputBase-input": {
          height: "auto !important",
          padding: "8.5px 14px !important",
        },
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(4, 1fr)",
          },
          rowGap: 2,
          columnGap: 2,
        }}
      >
        {/* Group 1: Member ID & Member Name */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          <InputField
            label="Member ID"
            name="memberId"
            onChange={handleMemberIdChange}
          />
          <InputField
            label="Member Name"
            name="fullName"
            onChange={handleMemberNameChange}
          />
        </Grid>

        {/* Group 2: Empty */}
        <Grid
          item
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          {/* Empty group for future use */}
        </Grid>

        {/* Group 3: Empty */}
        <Grid
          item
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          {/* Empty group for future use */}
        </Grid>

        {/* Group 4: Empty */}
        <Grid
          item
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          {/* Empty group for future use */}
        </Grid>
      </Grid>
    </Box>
  );
}

export default PersonalDetailsSearch;
